// src/components/soldLeads/SoldLeadsModals.jsx
import React from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  FormControl,
  FormLabel,
  Textarea,
  Input,
  Button,
  Text,
  Select,
} from '@chakra-ui/react';

/**
 * Props expected:
 * FORWARD:
 * - isForwardOpen
 * - onForwardClose
 * - forwardRecipients, setForwardRecipients
 * - forwardSubject, setForwardSubject
 * - forwardNote, setForwardNote
 * - savingForward
 * - onSaveForward
 *
 * CANCEL:
 * - isCancelOpen
 * - onCancelClose
 * - reasonPreset, setReasonPreset
 * - reasonText, setReasonText
 * - submittingCancel
 * - onSubmitCancel
 */
export default function SoldLeadsModals({
  // Forward
  isForwardOpen,
  onForwardClose,
  forwardRecipients,
  setForwardRecipients,
  forwardSubject,
  setForwardSubject,
  forwardNote,
  setForwardNote,
  savingForward,
  onSaveForward,
  // Cancel
  isCancelOpen,
  onCancelClose,
  reasonPreset,
  setReasonPreset,
  reasonText,
  setReasonText,
  submittingCancel,
  onSubmitCancel,
}) {
  return (
    <>
      {/* Forward modal */}
      <Modal isOpen={isForwardOpen} onClose={onForwardClose} isCentered size="lg">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Mark as forwarded (log only)</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <FormControl mb={3}>
              <FormLabel>To</FormLabel>
              <Input
                value={forwardRecipients}
                onChange={(e) => setForwardRecipients(e.target.value)}
                placeholder="surveyor@example.com"
              />
            </FormControl>
            <FormControl mb={3}>
              <FormLabel>Subject</FormLabel>
              <Input
                value={forwardSubject}
                onChange={(e) => setForwardSubject(e.target.value)}
              />
            </FormControl>
            <FormControl>
              <FormLabel>Note</FormLabel>
              <Textarea
                rows={10}
                value={forwardNote}
                onChange={(e) => setForwardNote(e.target.value)}
              />
            </FormControl>
            <Text mt={3} fontSize="sm" color="gray.600">
              This only logs that you forwarded the job using your own email client. It does not send emails.
            </Text>
          </ModalBody>
          <ModalFooter>
            <Button mr={3} onClick={onForwardClose} variant="ghost">
              Cancel
            </Button>
            <Button colorScheme="teal" onClick={onSaveForward} isLoading={savingForward}>
              Save
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      {/* Cancel Sale modal */}
      <Modal isOpen={isCancelOpen} onClose={onCancelClose} isCentered>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Cancel Sale</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Text mb={3} color="gray.600">
              This will move the job to <b>Cancelled</b> and remove it from Sales.
            </Text>
            <FormControl mb={3} isRequired>
              <FormLabel>Reason (preset)</FormLabel>
              <Select
                placeholder="Select reason"
                value={reasonPreset}
                onChange={(e) => setReasonPreset(e.target.value)}
              >
                <option value="Customer withdrew">Customer withdrew</option>
                <option value="Chose competitor">Chose competitor</option>
                <option value="Finance declined">Finance declined</option>
                <option value="Pricing dispute">Pricing dispute</option>
                <option value="Product unsuitable">Product unsuitable</option>
                <option value="Other">Other</option>
              </Select>
            </FormControl>
            {(reasonPreset === 'Other' || !reasonPreset) && (
              <FormControl>
                <FormLabel>Reason (free text)</FormLabel>
                <Textarea
                  value={reasonText}
                  onChange={(e) => setReasonText(e.target.value)}
                  placeholder="Type the reason…"
                />
              </FormControl>
            )}
          </ModalBody>
          <ModalFooter>
            <Button variant="ghost" mr={3} onClick={onCancelClose}>
              Close
            </Button>
            <Button colorScheme="red" onClick={onSubmitCancel} isLoading={submittingCancel}>
              Confirm Cancel
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}
